import { KeyValuePair } from '@msdk/definitions'

export const getValueFromLocalStorage = (k: string): any => {
  const item = window.localStorage.getItem(k)
  const value = item ? JSON.parse(item) : null
  return { key: k, value } as any
}

export const setValueToLocalStorage = (v: KeyValuePair) => {
  switch (typeof v.value) {
    case 'string':
      window.localStorage.setItem(v.key, v.value)
      break
    case 'object':
      window.localStorage.setItem(v.key, JSON.stringify(v.value))
      break
    default:
      throw new Error('Cannot parse type')
  }
}

export function useLocalStorage<T extends KeyValuePair>() {
  const getValue = (k: string): T => {
    return getValueFromLocalStorage(k)
  }

  return { getValue, setValue: setValueToLocalStorage }
}
